import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../core/service/common-service/common.service';

@Component({
  selector: 'app-titan-dealer-dashboard',
  templateUrl: './titan-dealer-dashboard.component.html',
  styleUrls: ['./titan-dealer-dashboard.component.scss']
})
export class TitanDealerDashboardComponent implements OnInit {
  displayedColumns: string[] = ['Date', 'Slot 1', 'Slot 2', 'Lunch', 'Slot 3', 'Slot 4'];
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  userId: string;
  userInfo: any;
  workShops = <any>[];
  isDateRangeInvalid = false;
  spinner: boolean;
  bay1dataSource: any = [];
  bay2dataSource: any = [];
  defaultLabel: string;

  constructor(
    private commonService: CommonService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.setDefaultDates();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))[0];
    this.defaultLabel = "Titan-Dealer-Dashboard";
    this.userId = localStorage.getItem("userId");
    if (localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) {
      this.getWorkshopDetails();
    }
    this.workShops = JSON.parse(localStorage.getItem('workshops'))[0];
    this.getTitanDealerDashboardData();
  }

  /**
* Name: getWorkshopDetails
* purpose: To get CRE assigned workshop details
*/
  getWorkshopDetails() {
    this.spinner = true;
    this.commonService.getWorkshopDetails(this.userId).subscribe(res => {
      if (res['responseCode'] == 0) {
        this.spinner = false;
        localStorage.setItem('workshops', JSON.stringify(res['responseData']));
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  getTitanDealerDashboardData() {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }

    const request = {
      workshopCode: this.workShops.workshopCode,
      fromDate: this.datePipe.transform(this.fromDate, "yyyy-MM-dd"),
      toDate: this.datePipe.transform(this.toDate, "yyyy-MM-dd")
    };

    this.commonService.getTitanDealerDashboardData(request).subscribe(
      (res: any) => {
        if (res.responseCode === 0) {
          this.bay1dataSource = this.processBayData(res.responseData.bay1Data);
          this.bay2dataSource = this.processBayData(res.responseData.bay2Data);
        } else {
          this.toastr.info(res.message);
        }
        this.spinner = false;
      },
      err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  private processBayData(bayData: any[]): any[] {
    const combinedData = [];
    const allSlots = {
      'Slot 1': 'Available',
      'Slot 2': 'Available',
      Lunch: 'Booked',
      'Slot 3': 'Available',
      'Slot 4': 'Available'
    };

    const bookedSlotsMap = new Map();
    const slotTimeRanges = {
      'Slot 1': { start: '10:00:00', end: '11:30:00' },
      'Slot 2': { start: '11:30:00', end: '13:00:00' },
      'Lunch': { start: '13:00:00', end: '14:00:00' },
      'Slot 3': { start: '14:00:00', end: '15:30:00' },
      'Slot 4': { start: '15:30:00', end: '17:00:00' }
    };

    const fromDateStr = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    const toDateStr = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');

    // Generate all dates between fromDate and toDate (inclusive)
    const currentDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);
    currentDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);

    while (currentDate <= toDate) {
      const dateKey = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
      bookedSlotsMap.set(dateKey, { ...allSlots });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Populate the map with booked slots
    bayData.forEach(item => {
      const bookingDate = this.datePipe.transform(item.booking_dte, 'yyyy-MM-dd');

      if (bookingDate >= fromDateStr && bookingDate <= toDateStr) {
        const dateKey = this.datePipe.transform(item.booking_dte, 'dd/MM/yyyy');

        if (bookedSlotsMap.has(dateKey)) {
          for (const [slot, { start, end }] of Object.entries(slotTimeRanges)) {
            if (item.start_time >= start && item.end_time <= end) {
              bookedSlotsMap.get(dateKey)[slot] = 'Booked';
              break;
            }
          }
        } else {
          console.warn(`Date key ${dateKey} not found in bookedSlotsMap.`);
        }
      }
    });

    bookedSlotsMap.forEach((slots, date) => {
      combinedData.push({ Date: date, ...slots });
    });

    return combinedData;
  }

  getDashboardReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
  }

  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current);
    this.toDate = new Date(current);
    this.toDate.setDate(this.toDate.getDate() + 15);
  }

  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;

    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}
